'use client'
import { HIDDEN_FULL_MENU_PAGES } from "@/utils/constants"
import dynamic from "next/dynamic"
import { usePathname } from "next/navigation"
import Menu from "./Menu"


export default function MenuClient () {
  const pathname = usePathname()

  const shouldHide = HIDDEN_FULL_MENU_PAGES.some(path =>
    pathname.includes(path)
  )

  if (shouldHide) return null
  
  return (
    <Menu />
  )
}